import React, { useMemo, useState } from 'react';
import { Flex } from 'antd';
import { t } from 'i18next';
import { Period } from '../../../../api/types';
import { NavLink } from 'react-router-dom';
import { IconLinkToPeriod } from '../../../ui/icons/IconLinkToPeriod';
import dayjs from 'dayjs';

const dateFormat = 'YYYY-MM-DD';

interface ReportProps {
  period: Period,
  briefId: number,
}

const isQuarter = (period: Period) => {
  return period.periodLength === 0;
};

const isSemester = (period: Period) => {
  return period.periodLength === 2;
};

const getPeriodText = (period: Period) => {
  if (isQuarter(period)) {
    return `${t('info.forecast')} Q${period.quarter} ${period.year}`;
  }

  if (isSemester(period)) {
    const first = period.quarter === 1 || period.quarter === 2;
    const halfYear = first ? 1 : 2;
    return `${t('info.forecast')} H${halfYear} ${period.year}`;
  }

  return `${t('info.forecast')} ${dayjs(period.dateStart, dateFormat)
    .format(t('common.dateFormat'))} — ${dayjs(period.dateEnd, dateFormat).format(t('common.dateFormat'))}`;
};

export default function Forecast ({ period, briefId }: ReportProps) {

  return (
    <NavLink
      to={{ pathname: `/briefs/${briefId}/planner/${period.id}` }}
      className={'report-forecasts__link'}
    >
      <Flex gap={'small'} style={{ width: '100%' }} align={'center'} justify={'center'}>
        <IconLinkToPeriod/>
        {getPeriodText(period)}

      </Flex>
    </NavLink>
  );
}
